module.exports = __webpack_public_path__ + "static/AboutProfile-497943195453b743f4709337fcc4cd9e.png";